import { React, useState, useEffect, useRef } from "react";
import { PipeDesign, TableLayoutData } from "../../Pages/styledElements";
import {
  getShortJobCardCylinders,
  getShortJobCardCylindersMultistage,
} from "../../Services/deckleMatchServices";
import JobCardCylinder from "./JobCardCylinder";
import { TableList, RadioButtonStyle } from "../../Pages/pageStyled";
import { HaberForm } from "../../Pages/styledElements";
import Iconmoon from "../IconsFiles/icon";
import { Radio, Skeleton, Table, Tooltip } from "antd";
import moment from "moment";
import { lengthUnit } from "../../Utils/Constant/MeasurementUnitList";
import JobCardCylinderMultistage from "./JobCardCylinderMultistage";
import styled from "styled-components";
import { mergeReels } from "../../Utils/helper/helper";
function onChange(pagination, filters, sorter, extra) {
  console.log("params", pagination, filters, sorter, extra);
}
const CardShimmerStyle = styled.div`
  .ant-card-body {
    position: relative;
    z-index: 0;
    overflow: hidden;
    height: 100%;
    padding: 0px;
  }
  .ant-skeleton-element .ant-skeleton-button {
    min-width: 0px;
    width: 100%;
    border-radius: 3px;
  }
  .ant-skeleton-element .ant-skeleton-input {
    min-width: 0px;
    width: 100%;
    border-radius: 3px;
  }
  .ant-skeleton-element {
    width: 100%;
  }
  .ant-skeleton-element .ant-skeleton-image {
    min-width: 0px;
    width: 100%;
  }
`;
const JobCardCylinderContainerMultistage = ({
  // cylinderData,
  jobId,
  solution,
  multiView,
  deckle_match_page = false,
  print_function = null,
  isValidState = false,
  isTabularView = false,
  cancelSetToggle,
  reFetch = false,
  solId = "1",
  toggleFetchingData,
  collapse = true,
  deckleSize = "",
  isJobcardView = true,
  rewinderName = "",
  currentCylinderData,
  cylinderViewData
}) => {
  // console.log(currentCylinderData);
  const [gridView, setGridView] = useState(true);
  const [cylinderData, setCylinderData] = useState();
  const cylinderColumnHead = useRef([]);
  const [rerender, setRerender] = useState(false);
  const solutionId = solution ? `solution_${solution}`: null;
  const [isSetChanged, setIsSetChanged] = useState(false);
  useEffect(() => {
    if (cancelSetToggle) cancelSetToggle();
  }, [isSetChanged]);
  const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item?.slice(1);
  const [isFetchingDataForCylinder, setIsFetchingDataForCylinder] =
    useState(false);

  const handleCheckAvailableWidth = () => {
    const spanElement = document.getElementById(`cylinder-container`);
    // console.log(spanElement, document);
    if (spanElement) {
      const pixels = spanElement.offsetWidth;

      return pixels;
    }
    return "";
  };
  useEffect(() => {
    handleCheckAvailableWidth();
  }, [collapse, gridView]);
  // useEffect(() => {
  //   currentCylinderData && setCylinderData(currentCylinderData);
  // }, [currentCylinderData, jobId]);
  useEffect(() => {
    setGridView(!isTabularView);
  }, [isTabularView]);

  const calcMaxWidth = () => {
    const max = Math.max(
      ...cylinderData[solutionId].map((item) =>
        item.orders.reduce((sum, order) => sum + order.width, 0)
      )
    );
    const maxReels =
      Math.max(...cylinderData[solutionId].map((item) => item.orders.length)) -
      1;

    const maxDiff = Math.max(
      ...cylinderData[solutionId].map(
        (item) => max - item.orders.reduce((sum, order) => sum + order.width, 0)
      )
    );
    return { max, maxDiff, maxReels };
  };

  const [dataSet, setDataSet] = useState([]);

  const getUnits = (data) => {
    const u = data?.units;
    return {
      reelWidth: u ? lengthUnit[u.reel_width]?.displayName : "",
      trim: u ? lengthUnit[u.trim_loss]?.displayName : "",
      edgeL: u?.left_edge_trim ?? "cm",
      edgeR: u?.right_edge_trim ?? "cm",
    };
  };

  const buildCylinderColumns = (maxOrderCols) => {
    const cols = [];
    // always fixed at first position
    cols[0] = { title: "Combination No.", dataIndex: "combination", width: "0.005%", align: "center" };
    // dynamic columns based on max orders in any solution
    for (let c = 0; c < maxOrderCols; c++) {
      cols[c + 1] = { title: c + 1, dataIndex: c + 1, width: "0.02%", align: "center" };
    }
    const i = maxOrderCols + 1;
    const fixed = [
      { title: "D.Com Width", dataIndex: "total", width: "0.01%", align: "center" },
      { title: "Trim", dataIndex: "trim", width: "0.01%", align: "center" },
      { title: "Edge Trim (L)", dataIndex: "leftEdgeTrim", width: "0.1%", align: "center" },
      { title: "Edge Trim (R)", dataIndex: "rightEdgeTrim", width: "0.1%", align: "center" },
      { title: "Reel OD/Core OD", dataIndex: "reelSpecification", width: "0.1%", align: "center" },
      { title: "Del Date", dataIndex: "deldate", width: "0.1%", align: "center" },
      { title: "Sets", dataIndex: "sets", width: "0.01%", align: "center" },
    ];

    // insert fixed columns after dynamic order columns
    fixed.forEach((colname, index) => (cols[i + index] = colname));

    // remove total column if it is duplicated
    const totalIdx = cols.findIndex((c) => c.dataIndex === "total");
    // console.log("cols before", cols, totalIdx);
    if (cols.filter((c) => c.dataIndex === "total").length > 1 && totalIdx !== -1) {
      cols.splice(totalIdx, 1);
    }
    return cols;
  };

  const buildCylinderRow = (item, rowIndex, cylinderData, units) => {
    const totalWidth = (item.orders ?? []).reduce(
      (sum, o) => sum + (o.reel_width ?? 0),
      0
    );
    const u = cylinderData?.units ?? {};
    const row = {
      key: rowIndex + 1,
      combination: rowIndex + 1,
      total: totalWidth.toFixed(3) + " " + units.reelWidth,
      trim: item.trim_loss + " " + units.trim,
      reelSpecification: `${item.reel_od} ${u.reel_od ?? ""} / ${item.core_id} ${u.core_id ?? ""}`,
      deldate: moment(item.delivery_date).format("DD MMM YYYY"),
      sets: item.count,
      leftEdgeTrim: item.left_edge_trim + " " + units.edgeL,
      rightEdgeTrim: item.right_edge_trim + " " + units.edgeR,
      dcom: "0 " + units.edgeR,
    };
    (item.orders ?? []).forEach((order, orderIndex) => {
      if (order.item_type !== "trim_loss") {
        row[orderIndex + 1] = (order?.reel_width ?? 0) + " " + units.reelWidth;
      }
    });
    return row;
  };

  // console.log("cylinder", cylinderData);
  const handleViewChange = (e) => {
    // setGridView(e.target.value);
    if (e.target.value === "grid") {
      setGridView(true);
    } else {
      setGridView(false);
    }
    // console.log("view check", e.target.value);
  };

  useEffect(() => {
    if (!isJobcardView) return;
    var screen_width = window.screen.width;
    var divisor = 3;
    if (screen_width <= 1366) {
      if (deckle_match_page) {
        divisor = 3.8;
      } else {
        divisor = 4;
      }
    } else if (screen_width > 1366 && screen_width <= 1920) {
      divisor = 3.2;
    }
    var w = window.outerWidth / divisor;
    setIsFetchingDataForCylinder(true);

    if(solutionId){
        getShortJobCardCylindersMultistage(jobId, w,solutionId)
        .then((response) => {
          if(cylinderViewData === "production"){
            const data = mergeReels(response[solutionId]);
          setCylinderData({ ...response, [solutionId]: data });
        }
          else{
            setCylinderData(response);
          }
          
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setIsFetchingDataForCylinder(false);
        });
      }

    // return () => {
    //   setCylinderData(null);
    // };
  }, [jobId, isSetChanged,solutionId,cylinderViewData]);

  useEffect(() => {
    if (!cylinderData || !solutionId) return;
    const solutionItems = cylinderData[solutionId];
    if (!solutionItems?.length) {
      setDataSet([]);
      return;
    }
    const units = getUnits(cylinderData);
    const maxOrderCols = Math.max(
      ...solutionItems.map((item) => {
        let count =0;
        item.orders.map((order) => {
        //   if(order.item_type !== "trim_loss"){
        //     count = count + 1;
        // }
        count = count + 1;
      }
          
        );
        return count;
      }),
      0
    );
    cylinderColumnHead.current = buildCylinderColumns(maxOrderCols);
    const rows = solutionItems.map((item, i) =>
      buildCylinderRow(item, i, cylinderData, units)
    );
    setDataSet(rows);
    setRerender((r) => !r);
  }, [cylinderData, solutionId]);

  useEffect(() => {
    // console.log(dataSet);
  },[dataSet])

  return jobId && isJobcardView ? (
    <>
      {(isFetchingDataForCylinder || (!cylinderData && deckle_match_page)) && (
        <div
          style={{
            paddingTop: "50px",
            paddingBottom: "50px",
          }}
        >
          <CardShimmerStyle>
            <div
              style={{
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                opacity: "70%",
                width: "341.62px",
                marginTop: "60px",
              }}
            >
              <Skeleton.Image
                active={true}
                style={{
                  width: "105px",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              />
            </div>
          </CardShimmerStyle>
          {/* <div 
style={{
    fontFamily: "var(--sf-pro-display-m)",
    fontWeight: "500",
    fontSize: "14px",
    height: "16px",
    color: "#A19F9D",
    paddingTop: "20px",
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    width: "150px",
    textAlign: "center",
}}
>{heading}
</div> */}
          <div
            style={{
              paddingTop: "30px",
              fontFamily: "var(--sf-pro-display-m)",
              fontWeight: "400",
              fontSize: "12px",
              height: "20px",
              color: "#A19F9D",
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
              width: "311px",
              textAlign: "center",
            }}
          >
            {"Fetching jobcard details"}
          </div>
        </div>
      )}
      <p
        style={{
          // display: "flex",
          width: "100%",
          color: "black",
          fontSize: "14px",
          marginTop: "30px",
          padding: "0 10px",
          fontFamily: "var(--sf-pro-display-m)",
          display: isFetchingDataForCylinder ? "none" : "flex",
        }}
      >
        <span style={{ width: "50%" }}>Rewinder: {rewinderName}</span>
        <span style={{ width: "50%", textAlign: "right" }}>
          Deckle: {deckleSize}
        </span>
      </p>
      <PipeDesign>
        <div
          className="main-container"
          id="cylinder-container"
          style={{
            backgroundColor: isFetchingDataForCylinder && "white",
            display: isFetchingDataForCylinder ? "none" : "",
          }}
        >
          {/* {console.log(cylinderData, solutionId, gridView)} */}
          {gridView ? (
            cylinderData &&
            cylinderData[solutionId]?.map((item, index) => (
              <tr>
                <JobCardCylinderMultistage
                  cylinderData={item}
                  multiview={multiView}
                  units={cylinderData.units}
                  isValidState={isValidState}
                  jobId={jobId}
                  cancelSetToggle={() => setIsSetChanged(!isSetChanged)}
                  deckle_match_page={deckle_match_page}
                  maxWidth={calcMaxWidth()}
                  combinationNumber={index + 1}
                  solution={solutionId}
                  solId={solId}
                  maxAvailableWidth={handleCheckAvailableWidth()}
                  cylinderViewData={cylinderViewData}
                />
              </tr>
            ))
          ) : dataSet?.length && (
            <div className="list-grid-view">
              <TableLayoutData>
                <div className="tableDataFormat removePagnation">
                  <Table
                    columns={cylinderColumnHead.current}
                    dataSource={dataSet}
                    onChange={onChange}
                    scroll={{
                      x:
                        window.screen.width < 1000 &&
                        cylinderColumnHead.current.length * 1.2,
                    }}
                    pagination={false}
                  />
                </div>
              </TableLayoutData>
            </div>
          )}
        </div>
      </PipeDesign>
    </>
  ) : null;
};

export default JobCardCylinderContainerMultistage;
